"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _downshift = require("downshift");

var _ = require("../../");

var _chip = require("../../../chip");

var _context = require("../../../context");

var _expander = require("../../../expander");

var _OptionalExpander = require("../../../helpers/OptionalExpander");

var _dropdownList = require("../../../helpers/dropdown-list");

var _useStatePlacement2 = require("../../../helpers/dropdown-list/useStatePlacement");

var _tagList = require("../../../helpers/tag-list");

var _useTagRefocus2 = require("../../../helpers/tag-list/useTagRefocus");

var _layout = require("../../../layout");

var _screenReaderOnly = require("../../../screen-reader-only");

var _utils = require("../../../utils");

var _utils2 = require("../../utils");

var _constants = require("../constants");

var _utils3 = require("../utils");

var _DropdownContext = require("./DropdownContext");

var _DropdownExperimentalLayout = require("./DropdownExperimentalLayout");

var _DropdownSelectSearchField = _interopRequireDefault(require("./DropdownSelectSearchField"));

var _OptionalNavWrapper = require("./OptionalNavWrapper");

var _helpers = require("./helpers");

var _core = require("@emotion/core");

var _excluded = ["aria-describedby", "aria-invalid", "aria-required", "collapsedOptionsExpanderTitle", "customSelectionOptions", "customSelectionOptionsLabel", "defaultOptionsLabel", "defaultValue", "disabled", "disabledTagsHiddenText", "error", "experimentalLayoutProps", "filterOptions", "getTriggerText", "id", "isMulti", "isNavigation", "isSearchable", "labelId", "listMaxHeight", "listPositioningStrategy", "name", "navigationAriaLabel", "noOptionsText", "onChange", "options", "placeholder", "renderOption", "renderSelectedValue", "searchFieldAriaLabel", "selectedOptionAltText", "selectedOptionDismissAltText", "shouldCollapseSelectedOptions", "triggerId", "value", "valueAccessor", "virtualizedListProps", "warning", "width"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PlaceholderText = (0, _context.styledWithTheme)('span')(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.selectors.color(_constants.PLACEHOLDER_TEXT_COLOR),
    fontStyle: 'italic'
  };
});
var SelectedItemTag = (0, _context.styledWithTheme)(_chip.Chip)({
  height: 'auto',
  overflowWrap: 'anywhere'
});
var DropdownSelectBase = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, externalRef) {
  var ariaDescribedBy = _ref2['aria-describedby'],
      ariaInvalid = _ref2['aria-invalid'],
      ariaRequired = _ref2['aria-required'],
      _ref2$collapsedOption = _ref2.collapsedOptionsExpanderTitle,
      collapsedOptionsExpanderTitle = _ref2$collapsedOption === void 0 ? _constants.defaultProps.collapsedOptionsExpanderTitle : _ref2$collapsedOption,
      _ref2$customSelection = _ref2.customSelectionOptions,
      customSelectionOptions = _ref2$customSelection === void 0 ? [] : _ref2$customSelection,
      _ref2$customSelection2 = _ref2.customSelectionOptionsLabel,
      customSelectionOptionsLabel = _ref2$customSelection2 === void 0 ? _constants.defaultProps.customSelectionOptionsLabel : _ref2$customSelection2,
      _ref2$defaultOptionsL = _ref2.defaultOptionsLabel,
      defaultOptionsLabel = _ref2$defaultOptionsL === void 0 ? _constants.defaultProps.defaultOptionsLabel : _ref2$defaultOptionsL,
      defaultValue = _ref2.defaultValue,
      disabled = _ref2.disabled,
      _ref2$disabledTagsHid = _ref2.disabledTagsHiddenText,
      disabledTagsHiddenText = _ref2$disabledTagsHid === void 0 ? _constants.defaultProps.disabledTagsHiddenText : _ref2$disabledTagsHid,
      error = _ref2.error,
      experimentalLayoutProps = _ref2.experimentalLayoutProps,
      filterOptionsProp = _ref2.filterOptions,
      _ref2$getTriggerText = _ref2.getTriggerText,
      getTriggerText = _ref2$getTriggerText === void 0 ? _constants.defaultProps.getTriggerText : _ref2$getTriggerText,
      id = _ref2.id,
      isMulti = _ref2.isMulti,
      isNavigation = _ref2.isNavigation,
      isSearchable = _ref2.isSearchable,
      labelIdProp = _ref2.labelId,
      listMaxHeight = _ref2.listMaxHeight,
      listPositioningStrategy = _ref2.listPositioningStrategy,
      name = _ref2.name,
      navigationAriaLabel = _ref2.navigationAriaLabel,
      _ref2$noOptionsText = _ref2.noOptionsText,
      noOptionsText = _ref2$noOptionsText === void 0 ? _constants.defaultProps.noOptionsText : _ref2$noOptionsText,
      onChange = _ref2.onChange,
      options = _ref2.options,
      _ref2$placeholder = _ref2.placeholder,
      placeholderProp = _ref2$placeholder === void 0 ? _constants.defaultProps.placeholder : _ref2$placeholder,
      renderOption = _ref2.renderOption,
      renderSelectedValue = _ref2.renderSelectedValue,
      _ref2$searchFieldAria = _ref2.searchFieldAriaLabel,
      searchFieldAriaLabel = _ref2$searchFieldAria === void 0 ? _constants.defaultProps.searchFieldAriaLabel : _ref2$searchFieldAria,
      _ref2$selectedOptionA = _ref2.selectedOptionAltText,
      selectedOptionAltText = _ref2$selectedOptionA === void 0 ? _constants.defaultProps.selectedOptionAltText : _ref2$selectedOptionA,
      selectedOptionDismissAltText = _ref2.selectedOptionDismissAltText,
      shouldCollapseSelectedOptions = _ref2.shouldCollapseSelectedOptions,
      triggerId = _ref2.triggerId,
      propValue = _ref2.value,
      _ref2$valueAccessor = _ref2.valueAccessor,
      valueAccessor = _ref2$valueAccessor === void 0 ? _constants.defaultProps.valueAccessor : _ref2$valueAccessor,
      virtualizedListProps = _ref2.virtualizedListProps,
      warning = _ref2.warning,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? _constants.defaultProps.width : _ref2$width,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);

  // isDropdownFocused is needed to fix announcements from downshift for experimental layout with Clear button
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isDropdownFocused = _useState2[0],
      setIsDropdownFocused = _useState2[1];

  var componentId = (0, _react.useMemo)(function () {
    return "select-".concat((0, _utils.getUniqueId)());
  }, []);
  options = Array.isArray(options) ? options : _constants.defaultProps.options;
  var hasOptionGroups = (0, _helpers.isOptionGroupsAvailable)(options);

  var _useContext = (0, _react.useContext)(_context.StencilDialogContext),
      setHasOpenedDialog = _useContext.setHasOpenedDialog;

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      query = _useState4[0],
      setQuery = _useState4[1];

  var _useState5 = (0, _react.useState)((0, _utils3.getDefaultValue)({
    isMulti: isMulti,
    primaryValue: propValue,
    otherValue: defaultValue
  })),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      stateValue = _useState6[0],
      setStateValue = _useState6[1];

  var clearButtonRef = (0, _react.useRef)(null);
  var searchInputRef = (0, _react.useRef)(null);
  var triggerRef = (0, _react.useRef)(null);
  var ulRef = (0, _react.useRef)(null);
  var labelId = labelIdProp || (!!id ? (0, _utils2.buildLabelId)(id) : undefined);
  var disabledTagsTextId = disabled ? (0, _utils.getUniqueId)("disabled-hint-".concat(labelId)) : undefined;
  var hasNoOptions = options.length === 0;
  var isExperimentalLayout = !!experimentalLayoutProps;
  var isWithCustomSelectionOptions = isMulti && query.length === 0 && customSelectionOptions.length > 0;
  var itemToString = (0, _react.useCallback)(function (item) {
    return (0, _utils3.getItemToString)(item, {
      valueAccessor: valueAccessor
    });
  }, [valueAccessor]);
  var filterFunction;

  if (filterOptionsProp) {
    filterFunction = filterOptionsProp;
  } else {
    if (hasOptionGroups) {
      filterFunction = (0, _helpers.defaultFilterOptionGroupValues)(options, itemToString);
    } else {
      filterFunction = (0, _constants.defaultFilterOptions)(options, itemToString);
    }
  }

  var filteredOptions = (0, _react.useMemo)(function () {
    return isSearchable ? filterFunction(query) : options;
  }, [isSearchable, query, options, filterFunction]);
  var flattenOptions = (0, _react.useMemo)(function () {
    return hasOptionGroups ? (0, _helpers.flattenGroupOptions)(filteredOptions) : filteredOptions;
  }, [hasOptionGroups, filteredOptions]);

  var _useTagRefocus = (0, _useTagRefocus2.useTagRefocus)({
    inputRef: triggerRef,
    isMulti: isMulti,
    stateValue: stateValue
  }),
      tagDeleteRefs = _useTagRefocus.tagDeleteRefs,
      removeTagRef = _useTagRefocus.removeTagRef;

  var handleChange = function handleChange(changes) {
    var selectedItem = changes.selectedItem,
        isOpen = changes.isOpen;
    var newValue = selectedItem;

    if (isMulti) {
      if (selectedItem === null || selectedItem === undefined) {
        return;
      }

      var isSelected = (0, _utils3.containsValue)(selectedItem, stateValue, itemToString);

      if (isSelected) {
        var selectedItemIndex = 0;
        newValue = stateValue.filter(function (item, index) {
          if (itemToString(item) === itemToString(selectedItem)) {
            selectedItemIndex = index;
            return false;
          }

          return true;
        });
        removeTagRef(selectedItemIndex, isOpen);
      } else {
        newValue = [].concat((0, _toConsumableArray2.default)(stateValue), [selectedItem]);
      }
    }

    setStateValue(newValue);
    !!onChange && onChange(newValue);
  };

  var items = isSearchable && query.length > 0 ? flattenOptions : [].concat((0, _toConsumableArray2.default)(customSelectionOptions), (0, _toConsumableArray2.default)(flattenOptions));

  var _useSelect = (0, _downshift.useSelect)({
    id: id,
    itemToString: itemToString,
    items: items,
    initialSelectedItem: isMulti ? [] : stateValue,
    labelId: labelId,
    onIsOpenChange: function onIsOpenChange(changes) {
      switch (changes.type) {
        case _downshift.useSelect.stateChangeTypes.ToggleButtonKeyDownArrowUp:
        case _downshift.useSelect.stateChangeTypes.ToggleButtonKeyDownArrowDown:
        case _downshift.useSelect.stateChangeTypes.MenuKeyDownEnter:
        case _downshift.useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
        case _downshift.useSelect.stateChangeTypes.ItemClick:
        case _downshift.useSelect.stateChangeTypes.MenuBlur:
        case _downshift.useSelect.stateChangeTypes.ToggleButtonClick:
        case _downshift.useSelect.stateChangeTypes.MenuKeyDownEscape:
          setHasOpenedDialog(!!changes.isOpen);
          setQuery('');
          break;

        default:
          break;
      }
    },
    onSelectedItemChange: handleChange,
    selectedItem: stateValue,
    stateReducer: function stateReducer(state, updates) {
      // If the menu gets a blur event but the newly focused element is the
      // search field or footer button, don't close the menu.
      var type = updates.type,
          changes = updates.changes;
      setIsDropdownFocused(true);

      switch (type) {
        case _downshift.useSelect.stateChangeTypes.MenuKeyDownEnter:
          if (isMulti) {
            // Ensure Enter on multi-select closes the dropdown without selecting
            // the highlighted option.
            return _objectSpread(_objectSpread({}, changes), {}, {
              selectedItem: null,
              isOpen: false
            });
          }

        // eslint-disable-next-line no-fallthrough

        // eslint-disable-next-line no-fallthrough
        case _downshift.useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
        case _downshift.useSelect.stateChangeTypes.ItemClick:
          if (isMulti) {
            var newState = _objectSpread(_objectSpread({}, changes), {}, {
              isOpen: true,
              // keep menu open after selection.
              highlightedIndex: state.highlightedIndex
            });

            if ((0, _typeof2.default)(changes.selectedItem) === 'object' && changes.selectedItem.hasOwnProperty('onClick')) {
              newState.selectedItem = null; // Delay is needed to avoid update while state is updated

              // Delay is needed to avoid update while state is updated
              setTimeout(function () {
                changes.selectedItem.onClick();
              }, 10);
            }

            return newState;
          }

        // Fallthrough

        // Fallthrough
        case _downshift.useSelect.stateChangeTypes.MenuBlur:
          if (isSearchable) {
            if (searchInputRef.current) {
              var activeElementInScope = (0, _utils.getActiveElement)(searchInputRef.current, {
                closedShadowDom: true
              });

              if (searchInputRef.current === activeElementInScope) {
                return _objectSpread(_objectSpread({}, changes), {}, {
                  isOpen: state.isOpen
                });
              }
            }
          } else if (clearButtonRef.current) {
            // Delay is needed to avoid update while button gets focused
            setTimeout(function () {
              var activeElementInScope = (0, _utils.getActiveElement)(clearButtonRef.current, {
                closedShadowDom: true
              });

              if (clearButtonRef.current !== activeElementInScope) {
                closeMenu();
              }
            }, 10);
            return _objectSpread(_objectSpread({}, changes), {}, {
              isOpen: state.isOpen
            });
          }

          return changes;

        case _downshift.useSelect.stateChangeTypes.ToggleButtonClick:
          if (isSearchable && clearButtonRef.current) {
            var _activeElementInScope = (0, _utils.getActiveElement)(searchInputRef.current, {
              closedShadowDom: true
            });

            if (searchInputRef.current === _activeElementInScope) {
              clearButtonRef.current.focus();
              return _objectSpread(_objectSpread({}, changes), {}, {
                isOpen: state.isOpen
              });
            }
          }

          return changes;

        case _downshift.useSelect.stateChangeTypes.MenuKeyDownCharacter:
          // If the select is searchable, disable the downshift
          // behaviour of highlighting items as the user types,
          // since it conflicts with the filtering
          if (isSearchable) {
            return _objectSpread(_objectSpread({}, changes), {}, {
              highlightedIndex: state.highlightedIndex
            });
          }

          return changes;

        case _downshift.useSelect.stateChangeTypes.MenuKeyDownArrowDown:
          if (clearButtonRef.current && state.highlightedIndex === items.length - 1) {
            clearButtonRef.current.focus();
            setIsDropdownFocused(false);
          }

          return changes;

        default:
          return changes;
      }
    }
  }),
      closeMenu = _useSelect.closeMenu,
      getItemProps = _useSelect.getItemProps,
      getLabelProps = _useSelect.getLabelProps,
      getMenuProps = _useSelect.getMenuProps,
      getToggleButtonProps = _useSelect.getToggleButtonProps,
      highlightedIndex = _useSelect.highlightedIndex,
      isOpen = _useSelect.isOpen,
      setHighlightedIndex = _useSelect.setHighlightedIndex;

  var handleClear = function handleClear() {
    var newValue = isMulti ? [] : undefined;
    setStateValue(newValue);
    !!onChange && onChange(newValue);
    closeMenu();
  };

  var handleHighlightLastItem = function handleHighlightLastItem() {
    var _ulRef$current;

    setIsDropdownFocused(true);
    setHighlightedIndex(items.length - 1);
    ulRef === null || ulRef === void 0 ? void 0 : (_ulRef$current = ulRef.current) === null || _ulRef$current === void 0 ? void 0 : _ulRef$current.focus();
  }; // Used to force update before render finish if passed propValue is different from local value state,
  // This is cheaper than useEffect because useMemo runs synchronously without waiting the render cycle.


  (0, _react.useMemo)(function () {
    if (propValue !== undefined && !(0, _utils3.areValuesEqual)(stateValue, propValue, valueAccessor)) {
      setStateValue(propValue);
    }
  }, [propValue, stateValue, valueAccessor]);
  var renderOptionWithCheckmarks = (0, _react.useCallback)(function (option) {
    var optionRenderProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isSelected = (0, _utils3.areValuesEqual)(option, stateValue, itemToString);
    return (0, _core.jsx)(_layout.Row, {
      alignItems: "center",
      gridGap: "S200",
      padding: {
        left: hasOptionGroups ? _constants.GROUP_OPTION_LEFT_PADDING : 0
      }
    }, isSelected && (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, selectedOptionAltText, ", "), !!renderOption ? renderOption(option, optionRenderProps) : (0, _utils3.getItemToString)(option));
  }, [stateValue, itemToString, hasOptionGroups, selectedOptionAltText, renderOption]);
  var renderOptionWithCheckbox = (0, _react.useCallback)(function (option) {
    var optionRenderProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var value = itemToString(option);
    var isSelected = (0, _utils3.containsValue)(option, stateValue, itemToString);
    return (0, _core.jsx)(_layout.Row, {
      alignItems: "center"
    }, (0, _core.jsx)(_.Checkbox, {
      id: value,
      checked: isSelected,
      onChange: function onChange() {
        return null;
      },
      value: value
    }), (0, _core.jsx)(_layout.Spacer, {
      width: "S200",
      flexShrink: 0
    }), isSelected ? (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, selectedOptionAltText, ", ") : undefined, !!renderOption ? renderOption(option, optionRenderProps) : (0, _utils3.getItemToString)(option));
  }, [itemToString, stateValue, selectedOptionAltText, renderOption]);

  var renderSelectedItem = function renderSelectedItem(selectedItem, index) {
    var renderItem = renderSelectedValue || renderOption || itemToString;
    return (0, _core.jsx)(_tagList.TagListItem, {
      key: itemToString(selectedItem)
    }, (0, _core.jsx)(SelectedItemTag, {
      size: _chip.ChipSize.Small,
      dismissButtonAltText: selectedOptionDismissAltText,
      onDismiss: disabled ? undefined : function () {
        return handleChange({
          selectedItem: selectedItem
        });
      },
      dismissButtonRef: tagDeleteRefs[index]
    }, renderItem(selectedItem)), (0, _core.jsx)(_layout.Spacer, {
      width: "S200",
      flexShrink: 0
    }));
  };

  (0, _react.useEffect)(function () {
    return function () {
      return setHasOpenedDialog(false);
    };
  }, [setHasOpenedDialog]);
  var hasOpened = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    if (isSearchable) {
      if (isOpen && searchInputRef.current) {
        searchInputRef.current.focus();
        hasOpened.current = true;
      } else if (hasOpened.current && triggerRef.current !== null) {
        // Returning focus on Trigger
        triggerRef.current.focus();
      }
    }
  }, [isOpen, hasOpened, isSearchable]);
  var placeholder = isExperimentalLayout ? experimentalLayoutProps.labelText : (0, _core.jsx)(PlaceholderText, null, hasNoOptions ? noOptionsText : placeholderProp);
  var triggerContent;

  if (!!stateValue || stateValue === 0 || stateValue === false) {
    if (isMulti) {
      triggerContent = isMulti && stateValue && stateValue.length !== 0 ? getTriggerText(stateValue.length) : placeholder;
    } else if (!!renderSelectedValue) {
      triggerContent = renderSelectedValue(stateValue);
    } else if (!!renderOption) {
      var selectedOptionProps = {
        isRenderedAsPreview: true
      };
      triggerContent = renderOption(stateValue, selectedOptionProps);
    } else {
      triggerContent = itemToString(stateValue);
    }
  } else {
    triggerContent = placeholder;
  }

  var _useStatePlacement = (0, _useStatePlacement2.useStatePlacement)(isOpen),
      triggerBorderRadius = _useStatePlacement.inputProps,
      listBorderRadius = _useStatePlacement.listProps,
      onPlacementChange = _useStatePlacement.onPlacementChange;

  var isAriaDisabled = hasNoOptions || disabled;

  var dropdownTriggerProps = _objectSpread(_objectSpread({
    // The aria attributes don't meet the specification since they're
    // not intended to be applied to a <button>, but this is currently
    // the best known way for the information to actually be read by
    // screen readers. Applying it to the hidden <input> does not allow
    // it to be read out.
    'aria-describedby': ariaDescribedBy,
    'aria-disabled': isAriaDisabled,
    'aria-invalid': ariaInvalid,
    'aria-required': ariaRequired,
    children: triggerContent,
    disabled: disabled,
    error: error,
    getTriggerProps: getToggleButtonProps,
    id: triggerId,
    isOpen: isOpen,
    ref: (0, _utils.mergeRefs)(triggerRef, externalRef),
    warning: warning
  }, triggerBorderRadius), (0, _utils.omitDataProps)(forwardedProps));

  var dropdownContextValues = (0, _react.useMemo)(function () {
    return {
      isSearchable: isSearchable,
      selectedOptionAltText: selectedOptionAltText,
      withCustomSelectionOptions: isWithCustomSelectionOptions
    };
  }, [isSearchable, isWithCustomSelectionOptions, selectedOptionAltText]);
  var dropdownListComponentHeader;
  var showDropdownListComponentHeader = isSearchable && !isAriaDisabled;

  if (showDropdownListComponentHeader) {
    dropdownListComponentHeader = (0, _core.jsx)(_DropdownSelectSearchField.default, {
      ref: searchInputRef,
      query: query,
      onChange: function onChange(query) {
        setQuery(query);
      },
      setHighlightedIndex: setHighlightedIndex,
      ulRef: ulRef,
      triggerRef: triggerRef,
      ariaLabel: searchFieldAriaLabel,
      placeholder: isExperimentalLayout ? placeholderProp : undefined
    });
  }

  var dropdownListComponent = (0, _core.jsx)(_DropdownContext.DropdownContext.Provider, {
    value: dropdownContextValues
  }, (0, _core.jsx)(_dropdownList.DropdownList, (0, _extends2.default)({}, listBorderRadius, {
    customSelectionOptions: isWithCustomSelectionOptions ? customSelectionOptions : [],
    customSelectionOptionsLabel: customSelectionOptionsLabel,
    componentId: componentId,
    dataTestComponent: "StencilSelectList",
    defaultOptionsLabel: defaultOptionsLabel,
    getItemProps: getItemProps,
    getListProps: getMenuProps,
    header: dropdownListComponentHeader,
    highlightedIndex: isDropdownFocused ? highlightedIndex : -1,
    items: filteredOptions,
    isAlwaysOpened: isExperimentalLayout,
    isMulti: isMulti,
    isNavigation: isNavigation,
    isOpen: isExperimentalLayout ? isExperimentalLayout : isOpen,
    itemToString: itemToString,
    labelId: labelId,
    target: triggerRef,
    listMaxHeight: listMaxHeight,
    listPositioningStrategy: listPositioningStrategy,
    renderItem: isMulti ? renderOptionWithCheckbox : renderOptionWithCheckmarks,
    selectedItem: !isMulti ? stateValue : undefined,
    selectedItems: isMulti ? stateValue : undefined,
    ulRef: ulRef,
    virtualizedListProps: virtualizedListProps,
    width: isExperimentalLayout ? width : undefined,
    onPlacementChange: onPlacementChange,
    hasOptionGroups: hasOptionGroups
  })));
  return (0, _core.jsx)(_OptionalNavWrapper.OptionalNavWrapper, (0, _extends2.default)({
    "aria-label": navigationAriaLabel,
    isNavigation: isNavigation,
    width: isExperimentalLayout ? 'initial' : width
  }, (0, _utils.pickDataProps)(forwardedProps)), isExperimentalLayout ? (0, _core.jsx)(_DropdownExperimentalLayout.DropdownExperimentalLayout, (0, _extends2.default)({}, experimentalLayoutProps, {
    clearButtonRef: clearButtonRef,
    closeMenu: closeMenu,
    dropdownListComponent: dropdownListComponent,
    dropdownTriggerProps: dropdownTriggerProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    handleClear: handleClear,
    handleHighlightLastItem: handleHighlightLastItem,
    isOpen: isOpen,
    isMulti: isMulti,
    labelId: labelId,
    triggerContent: triggerContent,
    triggerRef: triggerRef,
    width: width
  })) : (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_dropdownList.DropdownTrigger, dropdownTriggerProps), dropdownListComponent), (id || name) && (0, _core.jsx)("input", {
    id: id,
    name: name,
    type: "hidden",
    value: stateValue,
    onChange: function onChange() {
      return (0, _utils3.getValueAsString)(stateValue, {
        valueAccessor: itemToString
      });
    }
  }), !isExperimentalLayout && isMulti && stateValue.length > 0 && (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_layout.Spacer, {
    height: "S200"
  }), (0, _core.jsx)(_OptionalExpander.OptionalExpander, {
    "aria-describedby": labelIdProp || ariaDescribedBy || (!!id ? (0, _utils2.buildLabelId)(id) : undefined),
    enabled: shouldCollapseSelectedOptions,
    size: _expander.ExpanderSize.Small,
    titleText: collapsedOptionsExpanderTitle
  }, disabled && (0, _core.jsx)("span", {
    "aria-hidden": true,
    hidden: true,
    id: disabledTagsTextId
  }, disabledTagsHiddenText), (0, _core.jsx)(_tagList.TagList, {
    "aria-describedby": disabledTagsTextId,
    "data-test-component": "StencilSelectedItemsList"
  }, stateValue.map(renderSelectedItem)))));
});
var DropdownSelect = (0, _utils.withTestAttributes)({
  component: 'StencilSelect'
})(DropdownSelectBase);
DropdownSelect.displayName = 'DropdownSelect';
var _default = DropdownSelect;
exports.default = _default;